import { X } from "lucide-react";
import type { PublicProfileDraft } from "../../lib/public-profile-store";
import { Drawer } from "../motion/drawer";
import { ProfileComposition } from "./ProfileComposition";

export function ProfileRail({
  open,
  profile,
  onClose,
}: {
  open: boolean;
  profile: PublicProfileDraft;
  onClose: () => void;
}) {
  return (
    <Drawer
      open={open}
      onOpenChange={(next) => !next && onClose()}
      ariaLabel={`${profile.displayName || "User"} profile`}
      className="!w-[380px] !max-w-[calc(100vw-16px)] !border-[var(--fintheon-surface)] !bg-[var(--fintheon-bg)] !shadow-[-12px_0_24px_-20px_rgba(0,0,0,0.85)]"
      backdropClassName="!bg-black/28"
    >
      <div className="min-h-0 flex-1 overflow-y-auto px-5 pb-[max(24px,env(safe-area-inset-bottom))] pt-[max(20px,env(safe-area-inset-top))]">
        <ProfileComposition
          profile={profile}
          mode="view"
          actions={
            <button
              type="button"
              onClick={onClose}
              aria-label="Close profile rail"
              className="inline-flex size-11 items-center justify-center text-[var(--fintheon-text)]/48 transition-colors duration-150 hover:text-[var(--fintheon-text)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--fintheon-accent)]/55 md:size-8"
            >
              <X className="h-4 w-4" />
            </button>
          }
        />
      </div>
    </Drawer>
  );
}
